const ja_ui = {
  'title'       : '竜輝の護符検索',
  'rarity'      : 'レア',
  'ability'     : '效果',
  'condition'   : 'トリガー',
  'exclusive'   : '制限条件',
  'availability': '入手方法',
  'name'        : '名前',
  'search'      : '検索',
  'clear'       : 'クリア',
  'seasonal'    : '限定',
  'event'       : 'イベント',
  'collab'      : 'コラボ',
  'promo'       : '特典'
}

export default ja_ui